// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eJtMD","col":"styles_col__1EeDb"};